import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { uerpAdvantages } from "../uerpModulesData";

const UerpAdvantagesSection: React.FC = () => (
  <section className="wdev-process" aria-labelledby="uerp-advantages-title">
    <div className="container">
      <AnimatedSection className="wdev-section-head wdev-section-head--center">
        <h2
          id="uerp-advantages-title"
          className="wdev-section-head__title wdev-section-head__title--dark wdev-section-head__title--underline"
        >
          Platform Advantages
        </h2>
        <p className="uerp-section-lead uerp-section-lead--dark">
          A unified ERP built for universities, autonomous colleges, and multi-campus institutions.
        </p>
      </AnimatedSection>

      <div className="uerp-advantages-grid">
        {uerpAdvantages.map((advantage, index) => (
          <motion.div
            key={advantage}
            className="wdev-process__card uerp-advantage-card"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45, delay: index * 0.05 }}
            whileHover={{ y: -4, transition: { duration: 0.25 } }}
          >
            <p className="uerp-advantage-card__text">{advantage}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default UerpAdvantagesSection;
